import type React from 'react';

import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';
import { Button } from '@mui/material';
import { trackAnalyticsEvent } from '@ragu-components/ord-analytics';
import { useTranslate } from 'react-admin';

import { flowchartLogger } from 'src/lib/logger';
import { saveBlob } from 'src/lib/saveBlob';

interface ButtonDownloadProps {
  saveData: string;
}

export default function ButtonDownload({ saveData }: ButtonDownloadProps): React.ReactElement {
  const translate = useTranslate();

  const saveFile = (data: string, fileName: string = 'dialplan-backup'): void => {
    flowchartLogger.debug('Saving file:', fileName);
    flowchartLogger.debug('File data:', data);
    trackAnalyticsEvent('callflow_exported', { event_category: 'callflow', event_label: fileName });
    saveBlob(data, `${fileName}.txt`, 'txt');
  };

  return (
    <Button
      variant='outlined'
      color='info'
      sx={{ mx: 1 }}
      onClick={() => {
        saveFile(saveData);
      }}
    >
      <FileDownloadRoundedIcon />
      {translate('callflows.interface.saveAsFile')}
    </Button>
  );
}
